import React, {useContext, useEffect} from "react"
import {AssociatePerformanceContext} from "./context/AssociatePerformanceContext";
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Table, { TableRow, TableCell } from "@amzn/meridian/table"
import { AssociateFilterContext } from "./context/AssociateFilterContext";
import { FormattedMessage } from "react-intl";
import { getRefreshInterval } from "../util/Util";
import { getDocumentURL } from "../handler/ParentDataHandler";
import { getBaseUrl } from "../util/Util";
import Link from "@amzn/meridian/link";
import {CapabilityContext} from "../global/context/CapabilityContext";

const AssociatePerformance = () => {
    const {configViewModel} = useContext(CapabilityContext);
    const { states } = useContext(AssociateFilterContext)
    const { viewModel, dispatch } = useContext(AssociatePerformanceContext);

    const getData = (baseUrl) => {
        dispatch({ type: 'LOAD_VIEW', data: { dispatcher: dispatch, baseUrl } });
        dispatch({ type: 'LOAD_VIEW', data: { dispatcher: dispatch, baseUrl, stationConfig: configViewModel.stationConfig } });
    }

    const getAssociateLink = (loginId) => {
        getDocumentURL().then(documentUrl => {
            const searchURL = new URL(documentUrl.toString().replace('associatestage', 'search'));

            const startDate = new Date();
            startDate.setHours(0,0,0,0);
            const endDate = new Date();
            endDate.setDate(startDate.getDate() +1);
            endDate.setHours(0,0,0,0);

            const optionsObj = {
                "type": "ASSOCIATE",
                "startDate": startDate.getTime(),
                "endDate": endDate.getTime(),
            }

            const shareableLink = "/detailPage/" + loginId + '/' + JSON.stringify(optionsObj);
            searchURL.searchParams.set("shareableLink", shareableLink);
            window.open(searchURL.href, "_blank")
        });
    };

    useEffect(() => {
        getDocumentURL().then(result => {
            const baseUrl = getBaseUrl(result);
            getData(baseUrl);
            const interval = setInterval(() => {
                getData(baseUrl)
            }, getRefreshInterval());
            return () => clearInterval(interval);
        })
    }, []);

    const onSort = (sortDetails) => {
        dispatch({
            type: 'SORT_DATA',
            data: { column: sortDetails.sortColumn, direction: sortDetails.sortDirection }
        })
    }

    const sortedAssociatePerformance = [...viewModel.associatePerformance];
    sortedAssociatePerformance && sortedAssociatePerformance.sort((a, b) => {
        if (a[viewModel.sortPref.column] < b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? -1 : 1;
        }
        if (a[viewModel.sortPref.column] > b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? 1 : -1;
        }
        return 0;
    })

    return (
        <div>
            <Row widths={["grid-11"]} alignmentVertical="top" spacingInset="large">
                <div>
                    <Heading level={2} type="h400" alignment="left">
                        <FormattedMessage id="associate.associates" defaultMessage="Associates" />
                    </Heading>
                    <br />
                    <Table headerRows={1} spacing="small"
                        sortColumn={viewModel.sortPref.column}
                        sortDirection={viewModel.sortPref.direction}
                        onSort={onSort}>
                        <TableRow>
                            <TableCell sortColumn="alias">
                                <FormattedMessage id="associate.associate" defaultMessage="Associate" />
                            </TableCell>
                            <TableCell sortColumn="cartsPerHour" alignmentHorizontal="right">
                                <FormattedMessage id="associate.cartsPerHour" defaultMessage="Carts Per Hour" />
                            </TableCell>
                            <TableCell sortColumn="hourSpent" alignmentHorizontal="right">
                                <FormattedMessage id="associate.hours" defaultMessage="Hours" />
                            </TableCell>
                            <TableCell sortColumn="cartsHandled" alignmentHorizontal="right">
                                <FormattedMessage id="associate.totalCarts" defaultMessage="Total Carts" />
                            </TableCell>
                            <TableCell>
                                <FormattedMessage id="associate.active" defaultMessage="Active" />
                            </TableCell>
                            <TableCell sortColumn="location">
                                <FormattedMessage id="associate.location" defaultMessage="Location" />
                            </TableCell>
                        </TableRow>
                        {sortedAssociatePerformance.map(associate => (
                            (states.length === 0 || states.includes(associate.active)) ? (
                                <TableRow key={associate.alias}>
                                    <TableCell>
                                        <Link onClick={() => getAssociateLink(associate.loginId)} type="secondary"
                                              target="_blank" rel="noreferrer noopener">
                                            {associate.alias}
                                        </Link>
                                    </TableCell>
                                    <TableCell alignmentHorizontal="right">{associate.cartsPerHour}</TableCell>
                                    <TableCell alignmentHorizontal="right">{associate.hourSpent}</TableCell>
                                    <TableCell alignmentHorizontal="right">{associate.cartsHandled}</TableCell>
                                    <TableCell>{associate.active}</TableCell>
                                    <TableCell>{associate.location}</TableCell>
                                </TableRow>
                            ) : null
                        ))}
                    </Table>
                </div>
            </Row>
        </div>
    );
}

export default AssociatePerformance


// WEBPACK FOOTER //
// ./src/components/stageassociate/AssociatePerformance.js